'use strict';

var SideEffect = require('./SideEffect.cjs');
var medium = require('./medium.cjs');
var exports$1 = require('../../node_modules/use-sidecar/dist/es2015/exports.cjs');

var SideCar = exports$1.exportSidecar(medium.effectCar, SideEffect.RemoveScrollSideCar);

module.exports = SideCar;
//# sourceMappingURL=sidecar.cjs.map
